module.exports = __webpack_public_path__ + "website/img/618Icon1.5a6e8e77.svg";